/* eslint-disable react/display-name */
import React from "react";
import H5PQuestion from "../../../components/Question/H5PQuestion";
import { Avatar, Tag, Progress } from "antd";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { getHumanReadableMomentFromStamp } from './../../../util/DateUtil'
import { CheckCircleTwoTone, CloseCircleTwoTone } from "@ant-design/icons";
import LineIndicator from "../../../components/dashboard/Crypto/LineIndicator";
export const class_session_columns = [
  {
    title: 'Question',
    dataIndex: 'question_id',
    key: 'question_id',
    width: 400,
    render: (question_id) => (<div>
      <H5PQuestion question_guid={question_id} />
    </div>),
  },
  // {
  //   title: 'Accuracy',
  //   dataIndex: 'correct_attempts',
  //   key: 'correct_attempts',
  //   width: 80,
  //   render: (text, item) => {
  //     return `${item.incorrect_attempts.length}/${item.total_count}`
  //   }
  // },
];

export const class_session_students_columns = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    render: (text, item) => {
      const { status, total_attempts = 0 } = item

      return (<div>
        <div>
          <Avatar src={item.avatar} />
          <Link to={`/main/student/${item.id}`}> {text}</Link>
        </div>
        <div>
          {(status !== 'notstarted') && (<div>
          <Progress  showInfo={false} percent={total_attempts * 10} size="small" status={status!== 'completed'?"active":"success"} />
          </div>)}
        </div>
      </div>)
    },
    sorter: (a, b) => a.name.length - b.name.length,
  },
  {
    title: 'Correct',
    dataIndex: 'total_sessions',
    key: 'total_sessions',
    render: (text, item) => item.attempts ? `${item.attempts.correct}/${item.attempts.total}` : "-"
  },
  {
    title: 'Points',
    dataIndex: 'points',
    key: 'points',
    render: (text) => text || "-"
  },
  {
    title: 'Completed',
    dataIndex: 'completed_time',
    key: 'completed_time',
    width: 100,
    render: (text, item) => {
      if (item.status === 'notstarted') return "Not started"
      if (item.status === 'inprogress') return "In progress"
      return (text ? getHumanReadableMomentFromStamp(parseInt(text)) : "-")
    }
  }
]

export const question_response_columns = [
  {
    title: 'Student',
    dataIndex: 'student',
    key: 'student',
    width: 100,
    render: (student) => {



      return (<div>
        <Avatar src={student.avatar} />
        <span>{student.name}</span>
      </div>)
    },
    sorter: (a, b) => a.student.length - b.student.length,
    sortDirections: ['descend', 'ascend'],
  },
  {
    title: '',
    dataIndex: 'status',
    key: 'status',
    width: 80,
    render: (status, item) => {
      return status ? <Tag color="#87d068">Correct</Tag> : (<Tag color="rgb(230, 100, 100)">Incorrect</Tag>)
    }
  },
];